// extracted by mini-css-extract-plugin
export default {"tabs":"dashboardNavbar_tabs__8fwE9","nav":"dashboardNavbar_nav__t554b","tabs__components":"dashboardNavbar_tabs__components__16-eo","activeTab":"dashboardNavbar_activeTab__gYRYa"};